import { http } from './http';
import { unwrapData } from '../utils/unwrapApiData';

export async function unifiedSearch(body) {
  const { data } = await http.post('/search', body);
  return unwrapData(data) ?? data;
}

export async function searchMeetings(body) {
  const { data } = await http.post('/search/meetings', body);
  return unwrapData(data) ?? data;
}

export async function searchMinutes(body) {
  const { data } = await http.post('/search/minutes', body);
  return unwrapData(data) ?? data;
}

export async function searchAgendaItems(body) {
  const { data } = await http.post('/search/agenda-items', body);
  return unwrapData(data) ?? data;
}

export async function searchTranscripts(body) {
  const { data } = await http.post('/search/transcripts', body);
  return unwrapData(data) ?? data;
}

export async function getSearchSuggestions(params) {
  const { data } = await http.get('/search/suggestions', { params });
  return unwrapData(data) ?? data;
}

export async function getSearchAnalytics(params = {}) {
  const { data } = await http.get('/search/analytics', { params });
  return unwrapData(data) ?? data;
}

